export default "__VITE_ASSET__aAeOPJE2__"